<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="1200px"
    custom-class="peopleDialog">
    <div class="title" slot="title">
      {{id ? '编辑' : '添加'}}
    </div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="月末在册学员人数" ref="student_num" prop="student_num">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.student_num" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="月末未消课时金额" ref="money" prop="money">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.money" class="inp">
                    <template  slot="append">
                      元
                    </template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="月末未消课时数量" ref="ksList" prop="ksList">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.ksList" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
<!--            <div v-for="(item,index) in ruleForm.ksList" :key="item.id">-->
<!--              <el-col :span="24">-->
<!--                <div class="title-flex">-->
<!--                  <b>月末未消课时（45分钟/课时）</b>-->
<!--                  <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="addKs()" alt="">-->
<!--                  <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="delKs(index)" alt="">-->
<!--                </div>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="月末未消课时名称"-->
<!--                              :ref="'ksList.' + index + '.name'"-->
<!--                              :prop="'ksList.' + index + '.name'"-->
<!--                              :rules="{-->
<!--                              required: false, message: '请选择', trigger: 'change'-->
<!--                            }">-->
<!--                  <div class="flex justify-start align-center">-->
<!--                    <el-select v-model="item.name" placeholder="请选择" class="inp">-->
<!--                      <el-option-->
<!--                        v-for="item in classes"-->
<!--                        :key="item.id"-->
<!--                        :label="item.name"-->
<!--                        :value="item.id">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
<!--                  </div>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="月末未消课时数量"-->
<!--                              :ref="'ksList.' + index + '.num'"-->
<!--                              :prop="'ksList.' + index + '.num'"-->
<!--                              :rules="{-->
<!--                              required: false, message: '请输入', trigger: 'blur'-->
<!--                            }">-->
<!--                  <div class="flex justify-start align-center">-->
<!--                    <el-input v-model="item.num" class="inp"></el-input>-->
<!--                  </div>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </div>-->
            <el-col :span="12">
              <el-form-item class="errorTips" label="上传证明" ref="file" prop="file">
                <div class="flex justify-start align-center">
                  <a :href="ruleForm.file" target="_blank" download rel="noopener" v-if="ruleForm.file"
                     class="look">查看证明</a>
                  <upload-file

                    name="file"
                    @uploadFile="uploadFile"
                  >
                    <div class="btnUp" slot="upload">
                      <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传证明
                    </div>
                  </upload-file>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <div class="flex justify-start align-center">
                <div class="btn-box">
                  <div class="btn" @click="submitForm('ruleForm')">确定</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </el-dialog>
</template>
<script>
import {imgUrl} from "@/config";
import {isYes} from "@/utils/const";
import {get_xueyuan,save_xueyuan} from "@/api";
import UploadFile from "@/components/UploadFile";
export default {
  name: "peopleDialog",
  data() {
    return {
      imgUrl:imgUrl,
      isYes:isYes,
      classes:[],
      ruleForm:{
        student_num: '', // 月末在册学员人数
        money: '', // 月末未消课时金额
        file: '', // 证明
        ksList:'', // 月末未消课时数量
        // ksList:[{
        //   name: '',
        //   num: '',
        //   id: Date.now()
        // }]
      },
      rules:{
        ksList: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        money: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        student_num: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        file: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
  },
  components: {UploadFile},
  created() {

  },
  methods: {
    async init(){
      let _data = await get_xueyuan(this.id);
      if(_data.status == 200){
        this.classes = _data.data.classes
        if(this.id){
          this.ruleForm = {
            student_num: _data.data.info.student_num, // 月末在册学员人数
            money: _data.data.info.money, // 月末未消课时金额
            ksList: _data.data.info.class_num, // 月末未消课时数量
            file: _data.data.info.file, // 证明
            // ksList: _data.data.info.class_num ? JSON.parse(_data.data.info.class_num) : [{
            //   name: '',
            //   num: '',
            //   id: Date.now()
            // }]
          }
        }
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo()
        }
      });
    },

    async submitInfo(){
      let _data = await save_xueyuan(
        this.ruleForm.student_num,
        this.ruleForm.money,
        this.ruleForm.file,
        this.ruleForm.ksList,
        this.id,
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
        this.handleClose()
      } else {
        this.$message.error(_data.msg)
      }
    },

    addKs() {
      this.ruleForm.ksList.push({
        name: '',
        num: '',
        id: Date.now()
      })
    },
    delKs(index) {
      this.ruleForm.ksList.splice(index, 1)
    },

    handleClose(){
      this.$refs.ruleForm.resetFields()
      this.$emit('handleClose',false)
    },

    uploadFile(data) {
      this.ruleForm[data.name] = data.file.url
    },
  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible) {
        this.init()
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.peopleDialog {
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
  .form-content {
    width: 100%;
    .title-flex {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 20px;

      b {
        font-size: 18px;
        color: #000000;
        font-weight: bold;
        margin-right: 10px;
      }
    }

    .width {
      width: 400px;
    }

    .btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 30px 0;

      .btn {
        width: 180px;
        height: 40px;
        background-image: linear-gradient(0deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .add {
      width: 24px;
      cursor: pointer;
    }

    .inp {
      flex: 1;
    }

    .tips {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      background-color: #fef0ef;
      border-radius: 4px;
      margin-left: 10px;
      font-size: 14px;
      color: #f34336;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 16px;

      i {
        font-size: 20px;
        color: #f34336;
        margin-right: 4px;
      }
      &.short {
        width: 120px;
      }
      &.zhengm {
        width: 250px;
      }
      &.width {
        width: 350px;
      }
    }

    .look {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      border: 1px solid #2791ff;
      color: #2791ff;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      margin-right: 10px;
      border-radius: 4px;
    }

    .btnUp {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      background-image: linear-gradient(90deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;

      i {
        font-size: 20px;
        color: #ffffff;
        margin-right: 5px;
        font-weight: 100;
      }
    }
  }
}
</style>


